export default __webpack_public_path__ + "static/media/0072.6df8b899.png";